/* eslint-disable @nx/enforce-module-boundaries */
import {
  Avatar,
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { MyTestimonialsContext } from '../context';
import {
  getUserFullName,
  getUserPosition,
  getUserProfilePic,
} from 'v4/lib/commons';
import { Controller, useForm } from 'react-hook-form';
import { ConnectionsDropdown } from 'v4/components/connections-dropdown';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const MyTestimonialsGiveTestimonialModal = forwardRef(
  ({ ...props }, ref) => {
    const {
      userProfileInfo,
      giveTestimonialMutation,
      giveTestimonialDisc,
      giveTestimonial,
      selected,
    } = useContext(MyTestimonialsContext);
    const { t } = useTranslator();
    const { formatNumber } = useNumberFormatter();
    const {
      handleSubmit,
      register,
      control,
      watch,
      formState: { errors },
    } = useForm({
      defaultValues: {
        // message: selected?.message,
        testimonial: selected?.testimonial,
      },
    });

    const onSubmit = (form) => {
      giveTestimonial({
        ...form,
        asker: form?.asker?.[0],
        form_type: 'GIVE',
        status: 'Given',
        id: selected?.id,
      });
    };
    return (
      <Modal size="2xl" {...props}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalHeader>
              <Heading color='#3D5A80' size="md">{t('profileTestimonials.giveTestimonial') || "Give a Testimonial"}</Heading>
              <ModalCloseButton />
            </ModalHeader>
            <ModalBody>
              <HStack alignItems="flex-start">
                <Avatar
                  name={getUserFullName(userProfileInfo)}
                  src={getUserProfilePic(userProfileInfo)}
                />
                <Stack spacing={4} flex={1}>
                  <Stack spacing={0}>
                    <Text fontWeight="bold">
                      {getUserFullName(userProfileInfo)}
                    </Text>
                    <Text size="sm">{getUserPosition(userProfileInfo)}</Text>
                  </Stack>
                  {selected?.id ? (
                    ''
                  ) : (
                    <FormControl>
                      <FormLabel>{t('profileTestimonials.pleaseChooseYourConnection') || "Please choose your connection"}</FormLabel>
                      <Controller
                        render={({ field }) => (
                          <ConnectionsDropdown type={"give"} max={1} {...field} />
                        )}
                        name="asker"
                        control={control}
                        rules={{ required: true }}
                      />
                    </FormControl>
                  )}
                  <FormControl isInvalid={errors?.testimonial}>
                    <Textarea
                      placeholder={`${t('profileTestimonials.exampleWorkedWith') || '"Ex: I have worked with"'} ${
                        selected?.asker
                          ? getUserFullName(selected?.asker)
                          : 'John'
                      } ${t('profileTestimonials.exampleMentor') || 'for many years. He has been a great mentor to me as I have worked my way up in our company.'}`}
                      {...register('testimonial', { 
                        required: true,
                        maxLength: {
                          value: 250,
                          message: t('profileTestimonials.testimonialCharacterLimit') || 'Testimonial must be 250 characters or less'
                        }
                      })}
                      maxLength={250}
                    />
                    <Text
                      color="#5B5B5B"
                      fontSize="12px"
                      textAlign="right"
                      fontWeight={400}
                    >
                   
                       {formatNumber(watch('testimonial')?.length || 0)}/{formatNumber(250)}

                    </Text>
                    {watch('testimonial')?.length >= 250 && (
                      <Text mb={2} fontSize="14px" color="red.500">
                        {' '}
                        {'Testimonial must be 250 characters or less'}
                      </Text>
                    )}
                    <FormErrorMessage>
                      {errors?.testimonial?.message || t('profileTestimonials.pleaseWriteTestimonial') || 'Please write a testimonial'}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl isInvalid={errors?.message}>
                    <FormLabel>
                      {t('profileTestimonials.writeMessageWithTestimonial') || "Write a message to send with your testimonial."}
                    </FormLabel>
                    <Textarea
                      // defaultValue={`Hello ${
                      //   selected?.asker
                      //     ? getUserFullName(selected?.asker)
                      //     : 'John'
                      // }. ${t('profileTestimonials.exampleTestimonialMessage') || 'I wanted to write a testimonial for your page.'}`}
                      placeholder={`${t('profileTestimonials.exampleHello') || 'Ex: Hello'} ${
                        selected?.asker
                          ? getUserFullName(selected?.asker)
                          : 'John'
                      }. ${t('profileTestimonials.exampleTestimonialMessage') || 'I wanted to write a testimonial for your page.'}`}
                      {...register('message', { 
                        required: true,
                        maxLength: {
                          value: 1000,
                          message: t('profileTestimonials.messageCharacterLimit') || 'Message must be 1000 characters or less'
                        }
                      })}
                      maxLength={1000}
                    />
                    <Text
                      color="#5B5B5B"
                      fontSize="12px"
                      textAlign="right"
                      fontWeight={400}
                    >
                      {/* {watch('message')?.length  || 0}/{1000} */}
                       {formatNumber(watch('message')?.length || 0)}/{formatNumber(1000)}

                      
                    </Text>
                    {watch('message')?.length >= 1000 && (
                      <Text mb={2} fontSize="14px" color="red.500">
                        {' '}
                        {'Message must be 1000 characters or less'}
                      </Text>
                    )}
                    <FormErrorMessage>{t('profileTestimonials.messageIsRequired') || "Message is required"}</FormErrorMessage>
                    <FormHelperText>
                    {t('profileTestimonials.note') || "Note"}:{' '}
                      {selected?.asker
                        ? getUserFullName(selected?.asker)
                        : 'Your connection'}{' '}
                      {t('profileTestimonials.approveChangesNotification') || "will be asked to approve your changes to this testimonial"}
                    </FormHelperText>
                  </FormControl>
                </Stack>
              </HStack>
            </ModalBody>
            <ModalFooter>
              <HStack justifyContent="flex-end">
                <Button
                  borderRadius="40px"
                  onClick={(e) => giveTestimonialDisc?.onClose?.()}
                  variant="secondary"
                >
                  {t('buttons.cancel') || 'Cancel'}
                </Button>
                <Button
                  borderRadius="40px"
                  isLoading={giveTestimonialMutation?.isLoading}
                  type="submit"
                  variant="primary"
                  isDisabled={ watch('asker')?.length === 0}
                >
                  {selected?.asker?.id ? 'Update' : t('buttons.send') || 'Send'}
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    );
  }
);
